import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";
import useSelect from "~components/Form/hooks/useSelect";

const useFunilObraUnidadeMedida = ({ formikRef, funilObraGrupoProdutoId = 0, name = "funilObraUnidadeMedidaId", permitir = 0, showAll = true, showAllOptions = true }) => {
  const funilObraUnidadeMedidaSelect = useSelect("funilObraUnidadeMedidas");
  const [funilObraUnidadeMedida, setFunilObraUnidadeMedida] = useState(0);
  const [funilObraUnidadeMedidaObjeto, setFunilObraUnidadeMedidaObjeto] = useState({});
  const [fila, setFila] = useState(null);

  const [funilObraUnidadeMedidas, setFunilObraUnidadeMedidas] = useState([]);
  const [funilObraGrupoProdutoUnidadeMedida, setFunilObraGrupoProdutoUnidadeMedida] = useState([]);

  const fetchFunilObraUnidadeMedida = async () => {
    const medidas = [];
    await db.funilObraUnidadeMedidas.each((unidadeMedida) => {
      if (showAll || unidadeMedida.ativo || permitir == unidadeMedida.id) medidas.push(unidadeMedida);
    });
    setFunilObraUnidadeMedidas(medidas);
  };

  const fetchFunilObraGrupoProdutoUnidadeMedida = async () => {
    const grupoProduto = [];
    await db.funilObraGrupoProdutoUnidadeMedida.each((grupo) => {
      grupoProduto.push(grupo);
    });
    setFunilObraGrupoProdutoUnidadeMedida(grupoProduto);
  };

  useEffect(() => {
    fetchFunilObraUnidadeMedida();
    fetchFunilObraGrupoProdutoUnidadeMedida();
  }, []);

  useEffect(() => {
    fetchFunilObraUnidadeMedida();
    fetchFunilObraGrupoProdutoUnidadeMedida();
  }, [permitir]);

  const funilObraGrupoProdutoUnidadeMedidas = useMemo(() => {
    const result = {};
    for (const e of funilObraGrupoProdutoUnidadeMedida || []) {
      result[e.funilObraGrupoProdutoId + "/" + e.funilObraUnidadeMedidaId] = true;
    }
    return result;
  }, [funilObraGrupoProdutoUnidadeMedida]);

  const optionFunilObraUnidadeMedida = useMemo(() => {
    let temp = [];
    if ((funilObraGrupoProdutoId && funilObraGrupoProdutoId != 0) || showAllOptions) {
      temp = (funilObraUnidadeMedidas || []).filter((e) => 
        e.ativo && (showAllOptions || (Object.entries(funilObraGrupoProdutoUnidadeMedidas).length &&
            funilObraGrupoProdutoUnidadeMedidas[funilObraGrupoProdutoId + "/" + e.id]))
      );
    }
    return prepareForOptions(temp, ["nome"], "id");
  }, [funilObraGrupoProdutoUnidadeMedidas, funilObraGrupoProdutoId]);

  useEffect(() => {
    if (
      funilObraUnidadeMedida &&
      funilObraGrupoProdutoId &&
      funilObraGrupoProdutoId != 0 &&
      funilObraGrupoProdutoUnidadeMedidas
    ) {
      const exists = (funilObraUnidadeMedidas || []).find(
        (e) =>
          e.id == funilObraUnidadeMedida &&
          Object.entries(funilObraGrupoProdutoUnidadeMedidas).length > 0 &&
          funilObraGrupoProdutoUnidadeMedidas[funilObraGrupoProdutoId + "/" + e.id]
      );

      if (!exists) {
        onChangeFunilObraUnidadeMedida({
          value: null,
        });
      }
    }
  }, [optionFunilObraUnidadeMedida, funilObraGrupoProdutoId]);

  useEffect(() => {
    if (funilObraUnidadeMedidas?.length > 0) {
      setFunilObraUnidadeMedidaObjeto(getColumnIntoKey({ data: funilObraUnidadeMedidas, prefix: "id-" }));
    }
  }, [funilObraUnidadeMedidas]);

  //FUNIL-OBRA-GRUPO-PRODUTO-UNIDADE-MEDIDA

  useEffect(() => {
    if (
      fila &&
      funilObraGrupoProdutoUnidadeMedidas &&
      Object.keys(funilObraGrupoProdutoUnidadeMedidas).length > 0 &&
      optionFunilObraUnidadeMedida &&
      optionFunilObraUnidadeMedida.length > 0
    ) {
      setSelectFunilObraUnidadeMedida(fila);
    }
  }, [fila, funilObraGrupoProdutoUnidadeMedidas, optionFunilObraUnidadeMedida]);

  function setSelectFunilObraUnidadeMedida(value, b) {
    if (
      funilObraUnidadeMedidas?.length &&
      optionFunilObraUnidadeMedida &&
      optionFunilObraUnidadeMedida.length > 0
    ) {
      const optionUnidadeMedida = (funilObraUnidadeMedidas || []).find((medida) => medida.id == value);

      if (optionUnidadeMedida) {
        onChangeFunilObraUnidadeMedida(
          {
            label: optionUnidadeMedida.nome,
            value: optionUnidadeMedida.id,
          },
          b
        );
      }
      setFila(null);
    } else {
      setFila(value);
    }
  }

  function onChangeFunilObraUnidadeMedida(e, b) {
    funilObraUnidadeMedidaSelect.upDateValue(e.value);
    funilObraUnidadeMedidaSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue(name, e.value);
      setTimeout(() => formikInstance.setFieldTouched(name, true));
    }
    setFunilObraUnidadeMedida(e.value);
  }

  return {
    funilObraUnidadeMedidaObjeto,
    funilObraGrupoProdutoUnidadeMedidas,
    funilObraUnidadeMedida,
    optionFunilObraUnidadeMedida,
    onChangeFunilObraUnidadeMedida,
    funilObraUnidadeMedidas,
    funilObraUnidadeMedidaSelect,
    setFunilObraUnidadeMedida,
    setSelectFunilObraUnidadeMedida,
  };
};

export default useFunilObraUnidadeMedida;
